import React from "react";
import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import StudentAuth from "./components/StudentAuth";
import StudentDashboard from "./components/StudentDashboard";
import Auth from "./components/Auth";
import { Layout, Menu, Button, Typography, Spin, Avatar, Space } from "antd";
import Lessons from "./components/Lessons";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Sidebar from "./components/Sidebar";
import FamilyMembers from "./components/FamilyMembers";
import LessonContent from "./components/LessonContent";
import Goals from "./components/Goals";
import Values from "./components/Values";
import Milestones from "./components/Milestones";
import DailyReports from "./components/DailyReports";
import Disciplines from "./components/Disciplines";
import Schedule from "./components/Schedule";
import Workbook from "./components/Workbook";

const { Header, Content } = Layout;
const { Title } = Typography;

const Dashboard = () => {
  const { user, signOut } = useAuth();

  return (
    <div>
      <Title level={2}>Dashboard</Title>
      <p>Welcome, {user.email}!</p>
      <Button onClick={signOut}>Sign Out</Button>
    </div>
  );
};

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const { user, loading, signOut, session } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {!user || window.location.pathname.includes("student") ? (
          <Routes>
            <Route path="/student/:familyId" element={<StudentAuth />} />
            <Route
              path="/student/:familyId/dashboard"
              element={<StudentDashboard />}
            />
            <Route
              path="/student/:familyId/workbook/:lessonId"
              element={<Workbook />}
            />
            <Route path="*" element={<Auth />} />
          </Routes>
        ) : (
          <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
              <Header style={{ padding: 0, background: "#fff" }}>
                <Space style={{ float: "right", marginRight: 20 }}>
                  <Avatar icon={<UserOutlined />} />
                  <span>{user.email}</span>
                  <Button
                    icon={<LogoutOutlined />}
                    onClick={signOut}
                    type="text"
                  >
                    Sign Out
                  </Button>
                </Space>
              </Header>
              <Content
                style={{ margin: "24px 16px", padding: 24, background: "#fff" }}
              >
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/family-members" element={<FamilyMembers />} />
                  <Route
                    path="/lessons"
                    element={<Lessons user={user} session={session} />}
                  />
                  <Route
                    path="/lesson-content/:lessonId"
                    element={<LessonContent />}
                  />
                  <Route path="/goals" element={<Goals />} />
                  <Route path="/values" element={<Values />} />
                  <Route path="/milestones" element={<Milestones />} />
                  <Route path="/daily-reports" element={<DailyReports />} />
                  <Route path="/schedule" element={<Schedule />} />
                  <Route path="/disciplines" element={<Disciplines />} />
                </Routes>
              </Content>
            </Layout>
          </Layout>
        )}
      </div>
    </Router>
  );
}
